<script>
import dialog from '@/components/Dialog'
export default {
  data () {
    return {
      managerId: '',
      password: '',
      showDialog: false,
      dialogOption: {
        showNo: false,
        text: '',
        cancelButtonText: 'いいえ',
        confirmButtonText: 'はい'
      },
      validateFlag: false,
      idValidateFlag: false,
      passwordValidateFlag: false
    }
  },
  components: {
    'v-dialog': dialog
  },
  created: function () {
    // 清空right-bar设置的Message相关两个seesion
    sessionStorage.removeItem('messageList')
    sessionStorage.removeItem('noMessageFlag')
  },
  methods: {
    login () {
      this.idValidateFlag = false
      this.passwordValidateFlag = false
      this.validateFlag = false
      if (this.managerId.trim() === '') {
        this.idValidateFlag = true
      }
      if (this.password === '') {
        this.passwordValidateFlag = true
      }
      if (this.managerId.trim() !== '' && this.password !== '') {
        let param = this.$qs.stringify({managerId: this.managerId, password: this.password})
        this.$axios.post('user/login', param)
          .then((response) => {
            // 存放WEB基础配置
            sessionStorage.setItem('uploadPictureMaxSize', response.data.uploadPictureMaxSize)
            // 存放当前登录用户的登录信息：用户名和权限标志
            sessionStorage.setItem('currentUserName', response.data.lastName + response.data.firstName)
            sessionStorage.setItem('currentUserRoleFlag', response.data.roleFlag)
            sessionStorage.setItem('googleMapUrl', response.data.googleMapUrl)
            sessionStorage.setItem('mapCenterDefaultLat', response.data.MapCenterDefaultLat)
            sessionStorage.setItem('mapCenterDefaultLng', response.data.MapCenterDefaultLng)
            this.$router.push({ name: 'MovementStatus' })
          })
          .catch((error) => {
            let status = error.status
            if (status === 400) {
              this.idValidateFlag = false
              this.passwordValidateFlag = false
              this.validateFlag = true
            }
            console.log(error)
          })
      }
    },
    // message dialog
    showMessage (title, yesNoFlag, yesText, noText) {
      this.dialogOption.text = title
      this.dialogOption.showNo = yesNoFlag
      this.dialogOption.confirmButtonText = yesText
      this.dialogOption.cancelButtonText = noText
      this.showDialog = true
      this.$refs.dialog
        .confirm()
        .then(() => {
          this.showDialog = false
        })
        .catch(() => {
          this.showDialog = false
        })
    }
  }

}
</script>

<template>
<div class="login">
  <div class="body">
    <div class="context">
      <div class="body-context">
        <div class="title" style="font-size: 28px;">
            <p>管理者ページ</p>
        </div>
        <div class="managerFont">
          <p class="F1-R-18">管理者 ID</p>
        </div>
        <div class="account">
          <input type='text' name='account' v-validate="'required'" class='inputstyles' v-model="managerId" />
        </div>
         <div class="accountError  textAlignLeft" v-show="idValidateFlag">
          <span  class="errorMessage">管理者IDを入力してください </span>
        </div>
        <div class="blankMargin">
        </div>
        <div class="passFont">
          <p class="F1-R-18">パスワ一ド</p>
        </div>
        <div class="password">
          <input type='password' maxlength="16" name='password' v-validate="'required'" class='inputstyles' v-model="password" @keyup.enter="login"/>
        </div>
         <div class="accountError  textAlignLeft"  v-show="passwordValidateFlag">
          <span class="errorMessage"> パスワードを入力してください </span>
        </div>
        <div class="accountError  textAlignLeft"  v-show="validateFlag">
          <span   class="errorMessage"> ユーザ認証に失敗しました </span>
        </div>
        <div class="blankMargin">
        </div>
        <div class="buttonStyle">
          <button style=" background: linear-gradient(#70b6ca 50%, #48a3be 50%)" @click="login">
            <p style="color:#fff;font-weight:600;font-size:23px;">ログイン</p>
          </button>
        </div>
        <div class="bottonFont01" >
          <p class="F1-R-18">管理者ID、パスワードを忘れた場合は</p>
        </div>
        <div class="bottonFont02">
          <p class="F1-R-18">直接管理者（マスター）にお問い合わせください</p>
        </div>
      </div>
    </div>
  </div>
 <v-dialog v-show="showDialog" :dialog-option="dialogOption" ref="dialog"></v-dialog>
</div>
</template>

<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100%;
  padding: 0px 35px 50px;
  .body {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #bfd7e1;
    .context {
      height: 68%;
      min-height: 495px;
      width: 52%;
      background-color: #fff;
      padding: 0 12%;
      .body-context {
        height: 100%;
        display: flex;
        flex-direction: column;
        .title {
          display: flex;
          justify-content: center;
          align-items: center;
          flex: 3.5;
          & > p {
            line-height: 150px;
            text-align: center;
          }
        }
        .managerFont {
          flex: 0.5;
          // height: 30px;
          & > p {
            line-height: 30px;
            text-align: left;
          }
        }
        .passFont {
          flex: 1;
          // height: 30px;
          margin-top: 10px;
          & > p {
            line-height: 30px;
            text-align: left;
          }
        }
        .account {
          flex: 0.5;
          height: 45px;
          border: solid 2px #ccc;
          border-radius: 10px;
          width: 98%;
        }
        .password {
          flex: 1;
          height: 45px;
          // margin-bottom: 25px;
          border: solid 2px #ccc;
          border-radius: 10px;
          width: 98%;
          margin-left: 0px;
        }
        input {
          float: left;
          border: none;
          background: none;
          outline: none;
          height: 100%;
          line-height: 38px;
          // 可以对应调整.text中的backgroud和下面的text-indent调整图标和input输入地方的间距
          // text-indent: 50px;
          // 去除浏览器输入框默认黄色背景
          &:-webkit-autofill,
          &:-webkit-autofill:hover,
          &:-webkit-autofill:focus {
            box-shadow:0 0 0 60px #fff inset;
            -webkit-text-fill-color: #878787;
          }
          .blankMargin{
          flex: 0.5;
          // height: 45px;
          // margin-bottom: 25px;
        }
        .accountError{
          flex:0.2;
          // margin-top: -23px;
        }
        }
        .buttonStyle {
          flex: 3;
          // height: 90px;
          position: relative;
          padding-top: 32px;
          & > button {
            height: 50px;
            width: 100%;
            // position: absolute;
            border-radius: 10px;
            // bottom: 0px;
            border: 0px;
            & > p {
              line-height: 58px;
            }
          }
        }
        .bottonFont01 {
          flex: 1;
          padding-top: 30px;
          & > p {
            font-size: 16px;
            font-weight: 500;
          }
        }
        .bottonFont02 {
          flex: 2;
          // padding-top: 5px;
          & > p {
            font-size: 16px;
            font-weight: 500;
          }
        }
      }
    }
  }
}
.inputstyles {
  width: 100%;
  height: 100%;
  line-height: 20px;
  font-size: 1.5em;
  text-align: left;
  border-radius: 10px;
  padding-left: 10px;
}
.errorMessage {
  color: red;
}
.textAlignLeft {
  text-align: left;
}

</style>



// WEBPACK FOOTER //
// src/router/views/Login.vue